// import React, { useState } from 'react'
import Header from '../components/Header'
import VerifyEmail from '../components/VerifyEmail'


const VerifyEmailPage = () => {

  return(
    <div className="py-12">
      <Header
        heading="Verifying Email"
        />
      <VerifyEmail />
    </div>
)
}

export default VerifyEmailPage
